
const domainNameLookup = {
    transportation: 'Transportation',
    electricity: 'Electricity',
    non_renewable_energy: 'Non-renewables',
    renewable_energy: 'Renewables',
    energy: 'Energy',
    energy_efficiency: 'Energy Efficiency'
};

export default domainNameLookup;